import React from 'react';

const notFound =()=>{
    return(
        <div className="mx-width">
            <h2 className="px-2 py-3">Not Found</h2>
        </div>
    )
}

export default notFound;